module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[76]197.fa0bdfa.woff2";